<template>
  <div>
    <div class="px-2 px-lg-5 py-lg-4 extra-rounded bg-white py-2">
      <div v-if="auction_status == 'hot'" class="col-12 bidding-hidden">
        <a :href="`/auctions/${auction_id}`">
          I auksjonens sluttfase kan du kun legge inn bud i auksjonslisten
        </a>
      </div>
      <div v-if="auction_status == 'active'" class="col-12 bidding-show">
        <div
          v-if="auction_type === 'open'"
          class="d-flex gap-2 my-2"
          role="group"
          aria-label="Basic example"
        >
          <a
            role="button"
            class="extra-rounded text-center btn-lg btn-primary dark-button"
            @click="newRate(lot.id, lot.rate + 500)"
            :ref="'btnLot500' + lot.id"
          >
            {{ trans('rates.add500') }}
          </a>
          <a
            role="button"
            class="extra-rounded text-center btn-lg btn-primary dark-button"
            @click="newRate(lot.id, lot.rate + 1000)"
            :ref="'btnLot1000' + lot.id"
          >
            {{ trans('rates.add1000') }}
          </a>
          <a
            role="button"
            class="extra-rounded text-center btn-lg btn-primary dark-button"
            @click="newRate(lot.id, lot.rate + 2000)"
            :ref="'btnLot2000' + lot.id"
          >
            {{ trans('rates.add2000') }}
          </a>
        </div>
        <div class="d-flex gap-2 my-2" role="group" aria-label="Basic example">
          <span class="font-s14 align-self-center fw-bold-500 back-text min-width-65">Fastbud</span>
          <input
            type="text"
            class="form-control"
            id="Fastbud"
            aria-describedby="Fastbud"
            v-model="rate"
          >
          <a
            role="button"
            class="px-10-py-5 main-group-btn align-self-center text-center btn-primary extra-rounded dark-button"
            @click="newRate(lot.id, rate)"
            :ref="'btnLotManual' + lot.id"
          >
            {{ trans('rates.add_manual') }}
          </a>
        </div>
        <div
          class="d-flex gap-2 my-2"
          role="group"
          aria-label="Basic example"
          v-if="auction_type === 'open'"
        >
          <span class="font-s14 align-self-center fw-bold-500 back-text min-width-65">Autobud</span>
          <input
            type="text"
            class="form-control"
            id="Maksbud"
            aria-describedby="Maksbud"
            placeholder="Maksbud"
            v-model="autoRate"
          >
          <a
            role="button"
            class="px-10-py-5 main-group-btn align-self-center text-center btn-primary extra-rounded dark-button"
            @click="newAutoRate(lot.id)"
            :ref="'btnLotAutoRate' + lot.id"
          >
            Autobud
          </a>
        </div>
        <div v-if="error !== undefined" class="row  mt-2">
          <div class="col-12">
            <div class="alert alert-danger" role="alert">
                {{ error }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="row ${1| ,row-cols-2,row-cols-3, auto,justify-content-md-center,|}  button-group-3 mt-5 mx-0 gap-2">
        <div class="col-7 align-self-center px-0">
          <question-component :lot_id="lot.id"/>
        </div>
        <div class="col px-0">
        </div>
      </div>
    </div>


    <div class="data-list">
      <!--    Høyeste bud-->
      <div
        v-if="lot.rate !== undefined && auction_type === 'open'"
        class="row ${1| ,row-cols-2,row-cols-3, auto,justify-content-md-center,|} dark-mob-bg extra-rounded my-2 px-lg-5 mid-light-bg mx-0"
      >
        <div class="col-6 px-0">
          <span class="text-white-mob font-s18 py-lg-2 p-2 d-block text-start fw-bold-600">Høyeste bud</span>
        </div>
        <div class="col-6 px-0">
          <span class="font-s14 px-2 py-2 d-block text-end fw-bold-600">
            <transition name="text" mode="out-in">
                            <div class="d-inline" :key="lot.rate">
                                {{ new Intl.NumberFormat('ru-RU').format(lot.rate) }}
                            </div>
                        </transition>
                   <br v-if="show_message_rate && me_rate"/>
            <strong v-if="show_message_rate && me_rate" class="text-success">(mitt bud)</strong>
          </span>
        </div>
        <div v-if="show_message_rate && !me_rate" class="col-12 px-0 ">
          <span class="font-s14 px-2 pb-2 d-block text-end fw-bold-600">
            <strong class="text-danger">(du har blitt overbudt!)</strong>
          </span>
        </div>
      </div>
      <!--      Ditt siste bud-->
      <div
        class="row ${1| ,row-cols-2,row-cols-3, auto,justify-content-md-center,|} dark-mob-bg extra-rounded my-2 px-lg-5 mid-light-bg mx-0">
        <div class="col-6 p-0">
          <span class="text-white-mob font-s18 py-lg-2 p-2 d-block text-start fw-bold-600">Ditt siste bud</span>
        </div>
        <div class="col-6 p-0">
          <span class="text-white-mob font-s18 py-lg-2 p-2 d-block text-end fw-bold-600">
               {{
              lot.rates !== undefined && lot.rates[0] !== undefined ? new Intl.NumberFormat('ru-RU').format(lot.rates[0].rate) : '0'
            }}
          </span>
        </div>
      </div>
      <!--      Ditt autobud-->
      <div
        v-if="lot.auto_rates !== undefined && lot.auto_rates[0] !== undefined && lot.auto_rates[0].rate >= lot.rate"
        class="row ${1| ,row-cols-2,row-cols-3, auto,justify-content-md-center,|} dark-mob-bg extra-rounded my-2 px-lg-5 mid-light-bg mx-0">
        <div class="col-6 p-0">
          <span class="text-white-mob font-s18 py-lg-2 p-2 d-block text-start fw-bold-600">Ditt autobud</span>
        </div>
        <div class="col-6 p-0">
          <span class="text-white-mob font-s18 py-lg-2 p-2 d-block text-end fw-bold-600">
                  {{ new Intl.NumberFormat('ru-RU').format(lot.auto_rates[0].rate) }}
          </span>
        </div>
      </div>
      <div
        v-if="lot.show_min_price"
        class="row ${1| ,row-cols-2,row-cols-3, auto,justify-content-md-center,|} dark-mob-bg extra-rounded my-2 px-lg-5 mid-light-bg mx-0">
        <div class="col-6 p-0">
          <span class="text-white-mob font-s18 py-lg-2 p-2 d-block text-start fw-bold-600">Minstepris</span>
        </div>
        <div class="col-6 p-0">
          <span class="text-white-mob font-s18 py-lg-2 p-2 d-block text-end fw-bold-600">
                  {{ new Intl.NumberFormat('ru-RU').format(lot.car.reserve_price) }}
          </span>
        </div>
      </div>
    </div>
    <!-- Reports -->
    <div class="mt-3 data-report px-lg-5 py-lg-2">
      <template
        v-if="!!lot.files"
        v-for="report in reports"
      >
        <div
          v-if="!!lot.files[report.erp]"
          v-for="reportLink in lot.files[report.erp]"
          class="row ${1| ,row-cols-2,row-cols-3, auto,justify-content-md-center,|} mb-2"
        >
          <div class="col-6  align-self-center">
            <h5 class="m-0 fw-bold-600 back-text">{{ report.header }}</h5>
          </div>
          <div class="col-6 ">
            <a
              role="button"
              target="_blank"
              :href="reportLink"
              class="px-10-py-5 extra-rounded text-center btn-primary dark-bg d-block text-decoration-none"
            >{{ report.button }}</a>
          </div>
        </div>
      </template>

      <!-- Legacy -->
      <template v-else>
        <!-- Tilstandsrapport -->
        <div v-if="tech_report_link !== ''"
            class="row ${1| ,row-cols-2,row-cols-3, auto,justify-content-md-center,|} mb-2">
          <div class="col-6  align-self-center">
            <h5 class="m-0 fw-bold-600 back-text">Tilstandsrapport</h5>
          </div>
          <div class="col-6 ">
            <a
              role="button"
              target="_blank"
              :href="tech_report_link"
              class="px-10-py-5 extra-rounded text-center btn-primary dark-bg d-block text-decoration-none"
            >Vis rapport</a>
          </div>
        </div>
        <div v-if="short_report_link !== ''"
            class="row ${1| ,row-cols-2,row-cols-3, auto,justify-content-md-center,|} mb-2">
          <div class="col-6  align-self-center">
            <h5 class="m-0 fw-bold-600 back-text">Tilstandssjekk</h5>
          </div>
          <div class="col-6 ">
            <a
              role="button"
              :href="short_report_link"
              target="_blank"
              class="px-10-py-5 extra-rounded text-center btn-primary dark-bg d-block text-decoration-none"
            >Vis rapport</a>
          </div>
        </div>
        <!--      Equipment report -->
        <div v-if="equipment_report_link !== ''"
            class="row ${1| ,row-cols-2,row-cols-3, auto,justify-content-md-center,|} mb-2">
          <div class="col-6  align-self-center">
            <h5 class="m-0 fw-bold-600 back-text">Vis utstyrsliste</h5>
          </div>
          <div class="col-6 ">
            <a
              role="button"
              :href="equipment_report_link"
              target="_blank"
              class="px-10-py-5 extra-rounded text-center btn-primary dark-bg d-block text-decoration-none"
            >Vis info</a>
          </div>
        </div>
        <!--      Vis utstyrsliste-->
        <div v-else-if="annet_report_link !== ''"
            class="row ${1| ,row-cols-2,row-cols-3, auto,justify-content-md-center,|} mb-2">
          <div class="col-6  align-self-center">
            <h5 class="m-0 fw-bold-600 back-text">Vis utstyrsliste</h5>
          </div>
          <div class="col-6 ">
            <a
              role="button"
              :href="annet_report_link"
              target="_blank"
              class="px-10-py-5 extra-rounded text-center btn-primary dark-bg d-block text-decoration-none"
            >Vis info</a>
          </div>
        </div>
        <!--      Vis Verkstedhistorikk-->
        <div v-if="garage_history_report_link !== ''"
            class="row ${1| ,row-cols-2,row-cols-3, auto,justify-content-md-center,|} mb-2">
          <div class="col-6  align-self-center">
            <h5 class="m-0 fw-bold-600 back-text">Vis Verkstedhistorikk</h5>
          </div>
          <div class="col-6 ">
            <a
              role="button"
              :href="garage_history_report_link"
              target="_blank"
              class="px-10-py-5 extra-rounded text-center btn-primary dark-bg d-block text-decoration-none"
            >Vis info</a>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import TimerComponent from "../TimerComponent";
import QuestionComponent from "../QuestionComponent";

export default {
  name: 'LotComponent',
  components: {QuestionComponent, TimerComponent},
  props: [
    'auction_id',
    'auction_type',
    'prop_lot',
    'tech_report_link',
    'annet_report_link',
    'short_report_link',
    'equipment_report_link',
    'garage_history_report_link',
    'prop_auction_hot',
    'auction_status'
  ],
  data: function () {
    return {
      error: undefined,
      lot: {
        images: [],
        car: {
          model: '',
          color: '',
          fuel: '',
          registration_number: '',
          brand: {}
        },
        rate: 0,
        rates: [],
        max_rate_customer: null,
        old_max_rate_client_user_id: null,
      },
      rate: '',
      autoRate: '',
      show_message_rate: false,
      me_rate: false,
      old_me_rate: false,
      auctionHot: false,
      reports: [
        {
          erp: 'Bruktbiltest',
          header: 'Tilstandsrapport',
          button: 'Vis rapport',
        },
        {
          erp: 'Tilstandssjekk',
          header: 'Tilstandsrapport',
          button: 'Vis rapport',
        },
        {
          erp: 'Annet',
          header: 'Annet',
          button: 'Vis info',
        },
        {
          erp: 'Utstyrsliste',
          header: 'Utstyrsliste',
          button: 'Vis info',
        },
        {
          erp: 'Verkstedhistorikk',
          header: 'Verkstedhistorikk',
          button: 'Vis info',
        },
      ],
    }
  },
  watch: {},
  mounted() {
    this.broadcast()
    this.lot = JSON.parse(this.prop_lot)
    this.checkMeRate(this.lot, this.lot)
    this.auctionHot = this.prop_auction_hot
  },
  created() {
    setInterval(this.ping, 5 * 60 * 1000);
  },
  methods: {
    ping() {
      axios.get('/ping')
    },
    broadcast() {
      Echo.private('lots.' + this.auction_id)
        .listen('update', (e) => {
          if (this.lot.id === e.lot.id) {
            this.checkMeRate(this.lot, e.lot)
            this.lot.rate = e.lot.rate
            this.lot.time_end = e.lot.time_end
          }
        })
        .listen('delete', (e) => {
          this.auctionHot = true
          this.auction_status = 'hot'
        })
      Echo.private('users.' + this.current_user_id)
        .listen('update', (e) => {
          this.lot.auto_rates[0] = e.auto_rate
        })
      Echo.private('hot_lots.' + this.auction_id)
        .listen('update', (e) => {
          if (this.lot.id === e.lot.id) {
            this.getLotRates()
            let rate = this.checkMeRate(this.slots[slot_number].lot, e.lot)
            if (rate.me_rate) {
              this.lot.rates.unshift({rate: e.lot.rate})
            }
            this.lot.me_rate = rate.me_rate
            this.lot.show_message_rate = rate.show_message_rate
            this.lot.rate = e.lot.rate
            this.lot.time_end = e.lot.time_end
          }
        })
        .listen('delete', (e) => {
          this.auctionHot = false
          this.auction_status = 'close'
        })
    },
    newRate(lot_id, amount) {
      this.error = undefined
      axios({
        url: `/auctions/${this.auction_id}/lots/ajax/${lot_id}`,
        method: 'PUT',
        data: {amount: amount}
      }).then(resp => {
        this.lot.rates = resp.data.lot.rates
      }).catch(err => {
        this.error = err.response.data.message
      })

      this.rate = ''
      this.autoRate = ''
      this.$refs['btnLot500' + lot_id].blur()
      this.$refs['btnLot1000' + lot_id].blur()
      this.$refs['btnLot2000' + lot_id].blur()
      this.$refs['btnLotManual' + lot_id].blur()
    },
    newAutoRate(lot_id) {
      this.error = undefined
      axios({
        url: `/auctions/${this.auction_id}/lots/ajax/${lot_id}/autorate`,
        method: 'PUT',
        data: {amount: this.autoRate}
      }).then(resp => {

      }).catch(err => {
        this.error = err.response.data.message
      })

      this.autoRate = ''
      this.rate = ''
      this.$refs['btnLot500' + lot_id].blur()
      this.$refs['btnLot1000' + lot_id].blur()
      this.$refs['btnLot2000' + lot_id].blur()
      this.$refs['btnLotManual' + lot_id].blur()
    },
    checkMeRate(old_lot, new_lot) {
      let me_rate = false
      let show_message_rate = false

      if (this.auction_type === 'open' && new_lot.rate != 0) {
        if (this.current_user_id == new_lot.max_rate_client_user_id) {
          me_rate = true
          show_message_rate = true
          this.lot.rates.unshift({rate: new_lot.rate})
        } else if (new_lot.old_max_rate_client_user_id == this.current_user_id && new_lot.max_rate_customer !== this.current_user_id) {
          show_message_rate = true
        }
      }

      this.me_rate = me_rate
      this.show_message_rate = show_message_rate

    },
  }
}
</script>
